export default __webpack_public_path__ + "static/media/users.cbb321af.svg";